export default __webpack_public_path__ + "static/media/lateralImgLogin.80e2873e.png";